/* REVENGE — theme behaviour. Loaded as a module after Horizon's importmap. */
import { StandardEvents, CartLinesUpdateEvent } from '@shopify/events';

const $ = (s, r = document) => r.querySelector(s);
const $$ = (s, r = document) => [...r.querySelectorAll(s)];
const reduceMotion = () => matchMedia('(prefers-reduced-motion: reduce)').matches;
const store = {
  get(k) { try { return localStorage.getItem(k); } catch (e) { return null; } },
  set(k, v) { try { localStorage.setItem(k, v); } catch (e) {} },
};

/* Grid re-layout: tiles glide via View Transitions, page itself is not cross-faded. */
window.rvRelayout = function (fn) {
  const cards = $$('.rv-grid .rv-card');
  if (!reduceMotion() && document.startViewTransition && cards.length) {
    cards.forEach((c, i) => { c.style.viewTransitionName = 'rv-card-' + i; });
    document.documentElement.classList.add('rv-vt-grid');
    let ran = false;
    const run = () => { if (!ran) { ran = true; fn(); } };
    const vt = document.startViewTransition(run);
    setTimeout(run, 400);
    vt.finished.finally(() => {
      document.documentElement.classList.remove('rv-vt-grid');
      cards.forEach((c) => { c.style.viewTransitionName = ''; });
    });
    return;
  }
  fn();
  if (!reduceMotion() && cards[0]?.animate) {
    cards.forEach((c, i) => c.animate([{ opacity: 0 }, { opacity: 1 }], { duration: 300, delay: Math.min(i, 24) * 8, fill: 'backwards' }));
  }
};

/* ---------------- Preloader (once per session) ---------------- */
(() => {
  const el = $('#rv-preloader');
  if (!el) return;
  const MIN = 1300, start = performance.now();
  let done = false;
  const finish = () => {
    if (done) return; done = true;
    setTimeout(() => {
      el.classList.add('is-leaving');
      document.documentElement.classList.remove('rv-preloading');
      try { sessionStorage.setItem('rv-preloaded', '1'); } catch (e) {}
      el.addEventListener('transitionend', () => el.remove(), { once: true });
      setTimeout(() => el.remove(), 1400);
    }, Math.max(0, MIN - (performance.now() - start)));
  };
  if (document.readyState === 'complete') finish(); else window.addEventListener('load', finish, { once: true });
  setTimeout(finish, 4000);
})();

/* ---------------- Add-to-cart toast ---------------- */
(() => {
  const el = $('#rv-toast');
  if (!el) return;
  const img = $('.rv-toast__img', el), title = $('.rv-toast__title', el), meta = $('.rv-toast__meta', el);
  let hideTimer;
  const hide = () => { el.classList.remove('is-visible'); setTimeout(() => { if (!el.classList.contains('is-visible')) el.hidden = true; }, 400); };
  const show = (info) => {
    if (!info) return;
    if (info.image) { img.src = info.image; img.hidden = false; } else img.hidden = true;
    title.textContent = info.product_title || '';
    const bits = [];
    if (info.variant_title && info.variant_title !== 'Default Title') bits.push(info.variant_title);
    if (info.quantity > 1) bits.push('×' + info.quantity);
    if (info.price_text) bits.push(info.price_text);
    meta.textContent = bits.join('  ·  ');
    el.hidden = false; el.classList.add('is-visible');
    clearTimeout(hideTimer); hideTimer = setTimeout(hide, 3800);
  };
  const fromPage = (form) => {
    const scope = form?.closest('.product-information') || $('.product-information') || document;
    const checked = scope.querySelector('input[type="radio"]:checked');
    const variant = checked ? (scope.querySelector('label[for="' + checked.id + '"]')?.textContent || checked.value) : '';
    return {
      product_title: (scope.querySelector('h1')?.textContent || '').trim(),
      variant_title: variant.trim(),
      price_text: scope.querySelector('.price')?.textContent.replace(/\s+/g, ' ').trim() || '',
      image: scope.querySelector('img')?.currentSrc || '',
      quantity: Number(form?.querySelector('input[name="quantity"]')?.value || 1),
    };
  };
  window.rvToast = show;
  $('.rv-toast__close', el)?.addEventListener('click', hide);
  $('.rv-toast__view', el)?.addEventListener('click', (e) => { const t = $('[data-testid="cart-drawer-trigger"]'); if (t) { e.preventDefault(); hide(); t.click(); } });
  document.addEventListener(StandardEvents.cartLinesUpdate, (event) => {
    if ((event.action || event.detail?.action) !== 'add' || event.rvQuick) return;
    const form = event.target?.closest?.('form') || event.target?.querySelector?.('form') || null;
    const info = fromPage(form);
    if (info.product_title) show(info);
  });
})();

/* ---------------- Pill cart button (mirrors the real cart) ---------------- */
(() => {
  const btns = $$('[data-rv-cart]');
  if (!btns.length) return;
  const setCount = (n) => $$('[data-rv-count]').forEach((el) => { el.textContent = n > 0 ? ' (' + n + ')' : ''; });
  btns.forEach((b) => b.addEventListener('click', (e) => { e.preventDefault(); const t = $('[data-testid="cart-drawer-trigger"]'); if (t) t.click(); else location.href = '/cart'; }));
  document.addEventListener(StandardEvents.cartLinesUpdate, (event) => {
    (event.promise || Promise.resolve()).then((r) => { const q = r?.cart?.totalQuantity; if (typeof q === 'number') setCount(q); }).catch(() => {});
  });
  const refresh = () => fetch('/cart.js', { headers: { Accept: 'application/json' } }).then((r) => r.json()).then((c) => setCount(c.item_count)).catch(() => {});
  window.addEventListener('pageshow', (e) => { if (e.persisted) refresh(); });
  refresh();
})();

/* ---------------- Cart dropdown: click outside closes ---------------- */
document.addEventListener('click', (e) => {
  const dlg = $('#cart-drawer .theme-drawer__dialog');
  if (!dlg || !dlg.open) return;
  if (e.target.closest('[data-rv-cart], [data-testid="cart-drawer-trigger"], .rv-toast, .rv-quick')) return;
  if (e.target === dlg) {
    const r = dlg.getBoundingClientRect();
    if (e.clientX >= r.left && e.clientX <= r.right && e.clientY >= r.top && e.clientY <= r.bottom) return;
  } else if (dlg.contains(e.target)) return;
  $('.theme-drawer__close-button', dlg)?.click();
}, true);

/* ---------------- Quick add (grid) ---------------- */
(() => {
  const sectionIds = () => $$('cart-items-component').map((c) => c.dataset.sectionId).filter(Boolean);
  async function add(btn, wrap) {
    const variantId = btn.dataset.variantId;
    if (!variantId || btn.disabled) return;
    btn.classList.add('is-busy');
    const deferred = CartLinesUpdateEvent.createPromise();
    const ev = new CartLinesUpdateEvent({ action: 'add', context: 'product', lines: [{ merchandiseId: variantId, quantity: 1 }], promise: deferred.promise });
    ev.rvQuick = true;
    document.dispatchEvent(ev);
    const fd = new FormData();
    fd.set('id', variantId); fd.set('quantity', '1');
    const ids = sectionIds(); if (ids.length) fd.set('sections', ids.join(','));
    try {
      const res = await fetch(window.Theme?.routes?.cart_add_url || '/cart/add', { method: 'POST', body: fd, headers: { Accept: 'application/json' } }).then((r) => r.json());
      if (res.status) throw new Error(res.message || 'Could not add');
      const ajaxCart = await fetch('/cart.js', { headers: { Accept: 'application/json' } }).then((r) => r.json());
      deferred.resolve({
        cart: CartLinesUpdateEvent.createCartFromAjaxResponse(ajaxCart),
        detail: { items: ajaxCart.items, source: 'revenge-quick-add', sourceId: 'rv-quick', itemCount: 1, productId: String(res.product_id || ''), sections: res.sections, didError: false },
      });
      window.rvToast?.({ product_title: wrap.dataset.productTitle, variant_title: btn.dataset.variantTitle, price_text: wrap.dataset.productPrice, image: wrap.dataset.productImage, quantity: 1 });
      btn.classList.add('is-added'); setTimeout(() => btn.classList.remove('is-added'), 1200);
    } catch (e) {
      deferred.reject(e);
      const label = btn.textContent;
      btn.classList.add('is-error'); btn.textContent = 'Sold out';
      setTimeout(() => { btn.classList.remove('is-error'); btn.textContent = label; }, 1500);
    } finally { btn.classList.remove('is-busy'); }
  }
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('.rv-quick__btn'); if (!btn) return;
    const wrap = btn.closest('[data-rv-quick]'); if (!wrap) return;
    e.preventDefault(); e.stopPropagation(); add(btn, wrap).then(() => btn.closest('.rv-card')?.classList.remove('is-quick-open'));
  }, true);
})();

/* ---------------- Grid: lazy hover images ---------------- */
(() => {
  const load = (card) => {
    const im = $('.rv-card__img--hover[data-src]', card);
    if (!im) return;
    im.src = im.dataset.src; if (im.dataset.srcset) im.srcset = im.dataset.srcset;
    im.removeAttribute('data-src'); im.removeAttribute('data-srcset');
  };
  document.addEventListener('pointerenter', (e) => { const c = e.target.closest?.('.rv-card'); if (c) load(c); }, true);
  document.addEventListener('touchstart', (e) => { const c = e.target.closest?.('.rv-card'); if (c) load(c); }, { passive: true, capture: true });
})();

/* ---------------- In-stock-only toggle ---------------- */
(() => {
  const toggles = $$('[data-stock-toggle]');
  if (!toggles.length) return;
  let on = store.get('rv-instock') === '1' || new URLSearchParams(location.search).get('stock') === 'in';
  const paint = () => {
    toggles.forEach((t) => { t.checked = on; });
    $$('.rv-grid').forEach((grid) => {
      grid.setAttribute('data-stock', on ? 'in' : 'all');
      const visible = $$('.rv-card', grid).filter((c) => !on || !c.classList.contains('is-sold-out')).length;
      const empty = grid.parentElement.querySelector('.rv-grid__empty--filter');
      if (empty) empty.hidden = visible > 0;
    });
    store.set('rv-instock', on ? '1' : '0');
  };
  toggles.forEach((t) => t.addEventListener('change', () => { on = t.checked; window.rvRelayout(paint); }));
  paint();
  window.rvStockPaint = paint;
})();

/* ---------------- Grid density (− / +) ---------------- */
(() => {
  const ctl = $('.rv-density'), sec = $('.rv-grid-section');
  if (!ctl || !sec) return;
  const mq = matchMedia('(max-width: 749px)');
  const DESK = [3, 4, 6, 8], MOB = [1, 2, 3];
  const cur = (v) => parseInt(getComputedStyle(sec).getPropertyValue(v)) || 0;
  let d = Math.max(0, DESK.indexOf(cur('--rv-cols') || 6)), m = Math.max(0, MOB.indexOf(cur('--rv-cols-mobile') || 2));
  const sd = store.get('rv-density-d'), sm = store.get('rv-density-m');
  if (sd !== null && DESK[+sd] !== undefined) d = +sd;
  if (sm !== null && MOB[+sm] !== undefined) m = +sm;
  const minus = $('[data-density="-"]', ctl), plus = $('[data-density="+"]', ctl);
  const paint = () => {
    sec.style.setProperty('--rv-cols', DESK[d]);
    sec.style.setProperty('--rv-cols-tablet', Math.min(DESK[d], 4));
    sec.style.setProperty('--rv-cols-mobile', MOB[m]);
    const idx = mq.matches ? m : d, len = mq.matches ? MOB.length : DESK.length;
    minus.disabled = idx === 0; plus.disabled = idx === len - 1;
    store.set('rv-density-d', String(d)); store.set('rv-density-m', String(m));
  };
  ctl.addEventListener('click', (e) => {
    const b = e.target.closest('[data-density]'); if (!b || b.disabled) return;
    const step = b.dataset.density === '+' ? 1 : -1;
    if (mq.matches) m = Math.min(MOB.length - 1, Math.max(0, m + step)); else d = Math.min(DESK.length - 1, Math.max(0, d + step));
    window.rvRelayout(paint);
  });
  mq.addEventListener?.('change', paint);
  paint();
})();

/* ---------------- Infinite scroll ---------------- */
(() => {
  const nav = $('[data-rv-infinite]'), grid = $('.rv-grid');
  if (!nav || !grid || !('IntersectionObserver' in window)) return;
  let next = nav.dataset.nextUrl, loading = false;
  if (!next) { nav.hidden = true; return; }
  nav.classList.add('is-infinite');
  const sentinel = document.createElement('div'); sentinel.className = 'rv-sentinel'; nav.after(sentinel);
  const io = new IntersectionObserver((en) => { if (en.some((e) => e.isIntersecting)) load(); }, { rootMargin: '800px 0px' });
  async function load() {
    if (!next || loading) return; loading = true; nav.classList.add('is-loading');
    try {
      const html = await fetch(next, { headers: { Accept: 'text/html' } }).then((r) => r.text());
      const doc = new DOMParser().parseFromString(html, 'text/html');
      doc.querySelectorAll('.rv-grid > .rv-card').forEach((c) => grid.appendChild(c));
      next = doc.querySelector('[data-rv-infinite]')?.dataset.nextUrl || '';
      window.rvStockPaint?.();
    } catch (e) { next = ''; }
    loading = false; nav.classList.remove('is-loading');
    if (!next) { io.disconnect(); nav.hidden = true; sentinel.remove(); }
  }
  io.observe(sentinel);
})();

/* ---------------- Live clock (viewer's local time, 24h, ms) ---------------- */
(() => {
  const els = $$('[data-rv-clock]');
  if (!els.length) return;
  const p2 = (n) => String(n).padStart(2, '0'), p3 = (n) => String(n).padStart(3, '0');
  const tick = () => {
    const d = new Date();
    const txt = `${p2(d.getMonth() + 1)}/${p2(d.getDate())}/${d.getFullYear()} ${p2(d.getHours())}:${p2(d.getMinutes())}:${p2(d.getSeconds())}.${p3(d.getMilliseconds())}`;
    els.forEach((e) => { e.textContent = txt; });
  };
  tick();
  if (reduceMotion()) setInterval(tick, 1000);
  else { const loop = () => { tick(); requestAnimationFrame(loop); }; requestAnimationFrame(loop); }
})();

/* ---------------- Trick or treat (Halloween game of chance) ---------------- */
(() => {
  const el = $('#rv-treat'), pill = $('#rv-treat-pill');
  if (!el) return;
  const KEY = 'rv-treat', d = el.dataset, test = d.test === 'true';
  const odds = Math.max(2, Number(d.odds) || 25), expiresMs = (Number(d.expires) || 15) * 60e3;
  let prizes = [];
  try { prizes = JSON.parse($('[data-rv-treat-prizes]', el)?.textContent || '[]'); } catch (e) {}
  const today = new Date().toISOString().slice(0, 10);
  const inWindow = (!d.start || today >= d.start) && (!d.end || today <= d.end);
  const read = () => { try { return JSON.parse(store.get(KEY) || 'null'); } catch (e) { return null; } };
  const write = (v) => store.set(KEY, JSON.stringify(v));
  const state = read();
  const pad = (n) => String(n).padStart(2, '0');
  const fmt = (ms) => { const s = Math.max(0, Math.round(ms / 1000)); return pad(Math.floor(s / 60)) + ':' + pad(s % 60); };
  const q = new URLSearchParams(location.search).get('treat');

  /* Live win: show the pill (not the modal) until the link expires. */
  const showPill = (st) => {
    if (!pill) return;
    pill.href = st.url; pill.hidden = false;
    const clock = $('[data-rv-treat-pill-clock]', pill);
    const tick = () => { const left = st.exp - Date.now(); if (left <= 0) { pill.hidden = true; return; } clock.textContent = fmt(left); setTimeout(tick, 1000); };
    tick();
  };
  if (state?.r === 'win' && state.exp > Date.now() && !(test && q)) { showPill(state); return; }

  if (!inWindow && !test) return;
  if (!prizes.length && !test) return;
  const cooldownMs = d.frequency === 'daily' ? 864e5 : d.frequency === 'cooldown' ? (Number(d.cooldown) || 30) * 60e3 : 0;
  const played = () => { if (test || q) return false; if (!state) return false; if (d.frequency === 'once') return true; if (d.frequency === 'always') return false; return Date.now() - state.t < cooldownMs; };
  if (played()) return;

  const stage = (name) => $$('[data-rv-treat-stage]', el).forEach((s) => { s.hidden = s.dataset.rvTreatStage !== name; });
  const open = () => { window.__rvTreat = true; el.hidden = false; requestAnimationFrame(() => el.classList.add('is-open')); };
  const close = () => { el.classList.remove('is-open'); setTimeout(() => { el.hidden = true; }, 350); if (!read() || read().r === undefined) write({ t: Date.now(), r: 'skip' }); };
  $$('[data-rv-treat-close]', el).forEach((b) => b.addEventListener('click', close));
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && !el.hidden) close(); });

  const win = () => {
    const p = prizes[Math.floor(Math.random() * prizes.length)] || { title: 'TEST PRIZE', url: '/', price: '$0', img: '' };
    const st = { t: Date.now(), r: 'win', url: p.url, exp: Date.now() + expiresMs };
    if (!test) write(st);
    $$('[data-rv-treat-link]', el).forEach((a) => { a.href = p.url; });
    const img = $('[data-rv-treat-img]', el); img.src = p.img; img.alt = p.title;
    $('[data-rv-treat-title]', el).textContent = p.title; $('[data-rv-treat-price]', el).textContent = p.price;
    el.classList.add('is-win'); stage('win');
    const clock = $('[data-rv-treat-clock]', el);
    const tick = () => { const left = st.exp - Date.now(); clock.textContent = fmt(left); if (left > 0) setTimeout(tick, 1000); else { $$('[data-rv-treat-link]', el).forEach((a) => { a.removeAttribute('href'); a.style.opacity = '0.4'; }); } };
    tick();
    if (!test) showPill(st);
  };
  const lose = () => {
    if (!test) write({ t: Date.now(), r: 'lose' }); el.classList.add('is-lose'); stage('lose');
    const cd = $('[data-rv-treat-cooldown]', el);
    if (cd && cooldownMs) { const until = Date.now() + cooldownMs; const tick = () => { const left = until - Date.now(); cd.textContent = fmt(left); if (left > 0) setTimeout(tick, 1000); }; tick(); }
  };
  const knock = () => {
    if (el.classList.contains('is-knocking')) return;
    el.classList.add('is-knocking');
    const won = (test && q === 'win') || Math.random() * odds < 1;
    setTimeout(() => { el.classList.remove('is-knocking'); won ? win() : lose(); }, reduceMotion() ? 300 : 1600);
  };
  $$('[data-rv-treat-knock]', el).forEach((b) => b.addEventListener('click', knock));
  $('[data-rv-treat-copy]', el)?.addEventListener('click', (e) => { const b = e.currentTarget; navigator.clipboard?.writeText(b.dataset.code).then(() => { b.classList.add('is-copied'); $('.rv-treat__code-hint', b).textContent = 'COPIED'; }); });

  stage('knock');
  window.__rvTreat = true;
  setTimeout(open, ($('#rv-preloader') ? 2200 : 800) + (Number(d.delay) || 0) * 1000);
})();

/* ---------------- Newsletter sheet ---------------- */
(() => {
  const el = $('#rv-newsletter');
  if (!el) return;
  const posted = !$('.rv-nl__input', el);
  const KEY = 'rv-nl';
  const DAYS = Number(el.dataset.days) || 30;
  const seen = () => { const v = store.get(KEY); if (!v) return false; if (v === 'done') return true; return Date.now() - Number(v) < DAYS * 864e5; };
  const open = () => { el.hidden = false; requestAnimationFrame(() => el.classList.add('is-open')); };
  const close = () => { el.classList.remove('is-open'); setTimeout(() => { el.hidden = true; }, 350); store.set(KEY, posted ? 'done' : String(Date.now())); };
  $$('[data-rv-nl-close]', el).forEach((b) => b.addEventListener('click', close));
  $$('[data-rv-nl-open]').forEach((b) => b.addEventListener('click', (e) => { e.preventDefault(); open(); }));
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && !el.hidden) close(); });
  if (posted) { open(); setTimeout(close, 3500); return; }
  // Auto-open is a theme setting (Theme settings → Newsletter popup) so the team can switch it off on drop days.
  const AUTO_OPEN = el.dataset.auto === 'true';
  if (!AUTO_OPEN || seen() || location.search.includes('customer_posted')) return;
  setTimeout(() => { if (!window.__rvTreat) open(); }, (Number(el.dataset.delay) || 2) * 1000 + ($('#rv-preloader') ? 1200 : 0));
})();

/* ---------------- PDP: details column sticky at vertical centre when it fits ---------------- */
(() => {
  const det = $('.product-information .product-details');
  if (!det) return;
  const set = () => {
    const hh = ($('#rv-header')?.offsetHeight || 62) + 16, h = det.offsetHeight;
    det.style.setProperty('--rv-details-top', (h < innerHeight - hh - 16 ? Math.max(hh, Math.round((innerHeight - h) / 2)) : hh) + 'px');
  };
  set();
  window.addEventListener('resize', set);
  if ('ResizeObserver' in window) new ResizeObserver(set).observe(det);
})();

/* ---------------- Media page: reveal + lightbox ---------------- */
(() => {
  const items = $$('[data-rv-reveal]');
  if (items.length) {
    if (!('IntersectionObserver' in window)) items.forEach((i) => i.classList.add('is-in'));
    else {
      const io = new IntersectionObserver((entries) => entries.forEach((en) => { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } }), { rootMargin: '0px 0px -10% 0px', threshold: 0.05 });
      items.forEach((i) => io.observe(i));
    }
  }
  const imgs = $$('.rv-media__item .rv-media__img');
  if (!imgs.length) return;
  const lb = document.createElement('div');
  lb.className = 'rv-lb'; lb.hidden = true;
  lb.innerHTML = '<button class="rv-lb__close" aria-label="Close">×</button><button class="rv-lb__nav rv-lb__prev" aria-label="Previous">‹</button><img class="rv-lb__img" alt=""><button class="rv-lb__nav rv-lb__next" aria-label="Next">›</button><div class="rv-lb__count"></div>';
  document.body.appendChild(lb);
  const img = $('.rv-lb__img', lb), count = $('.rv-lb__count', lb);
  let i = 0;
  const big = (src) => src.replace(/_\d+x(\d+)?(\.[a-z]+)/i, '$2');
  const show = (n) => { i = (n + imgs.length) % imgs.length; img.src = big(imgs[i].currentSrc || imgs[i].src); count.textContent = (i + 1) + ' / ' + imgs.length; };
  const open = (n) => { show(n); lb.hidden = false; requestAnimationFrame(() => lb.classList.add('is-open')); document.documentElement.classList.add('rv-no-scroll'); };
  const close = () => { lb.classList.remove('is-open'); document.documentElement.classList.remove('rv-no-scroll'); setTimeout(() => { lb.hidden = true; }, 300); };
  imgs.forEach((im, n) => im.closest('.rv-media__item').addEventListener('click', (e) => { if (!e.target.closest('a')) open(n); }));
  $('.rv-lb__close', lb).addEventListener('click', close);
  $('.rv-lb__prev', lb).addEventListener('click', () => show(i - 1));
  $('.rv-lb__next', lb).addEventListener('click', () => show(i + 1));
  lb.addEventListener('click', (e) => { if (e.target === lb) close(); });
  document.addEventListener('keydown', (e) => { if (lb.hidden) return; if (e.key === 'Escape') close(); if (e.key === 'ArrowRight') show(i + 1); if (e.key === 'ArrowLeft') show(i - 1); });
  let sx = 0;
  lb.addEventListener('touchstart', (e) => { sx = e.touches[0].clientX; }, { passive: true });
  lb.addEventListener('touchend', (e) => { const dx = e.changedTouches[0].clientX - sx; if (Math.abs(dx) > 40) show(i + (dx < 0 ? 1 : -1)); });
})();

/* ---------------- GACHA: tier page ---------------- */
/* Shopify-only flow. The pool is the smart collection gacha-<tier>. On buy we take the next in-stock prize
   in the chosen size (catalog order, so it just goes one after another), add the REAL variant with a hidden
   _gacha_tier property, remember it locally, and go straight to checkout. Inventory stops duplicates;
   the app's cart transform shows it as "$X PACK" at checkout. */
(() => {
  const root = $('[data-rv-gacha]');
  if (!root) return;
  const money = (n) => '$' + n;
  const norm = (v) => String(v || '').toUpperCase().replace(/[^A-Z0-9]/g, '');
  async function pickPrize(tier, size) {
    const r = await fetch(`/collections/gacha-${tier}/products.json?limit=250`, { headers: { Accept: 'application/json' } });
    if (!r.ok) throw new Error('pool');
    const products = ((await r.json()).products || []).sort((a, b) => a.id - b.id);
    const want = norm(size);
    for (const p of products) {
      const sizeIdx = p.options.findIndex((o) => /size/i.test(o.name));
      for (const v of p.variants) {
        const val = sizeIdx < 0 ? v.title : v['option' + (sizeIdx + 1)];
        if (!v.available || norm(val) !== want) continue;
        const img = (v.featured_image && v.featured_image.src) || (p.images[0] && p.images[0].src) || '';
        return { variantId: v.id, title: p.title, variantTitle: v.title, image: img, handle: p.handle };
      }
    }
    return null;
  }
  $$('.rv-gacha__tier', root).forEach((tier) => {
    if (tier.classList.contains('is-missing')) return;
    let sizes = {}; try { sizes = JSON.parse(tier.dataset.sizes || '{}'); } catch (e) {}
    const btns = $$('.rv-gacha__size', tier), buy = $('[data-buy]', tier), left = $('[data-left]', tier);
    const total = Object.values(sizes).reduce((a, b) => a + b, 0);
    left.textContent = total ? total + ' left' : 'Sold out';
    let chosen = null;
    btns.forEach((b) => {
      const n = sizes[b.dataset.size] ?? 0;
      if (!n) { b.disabled = true; b.classList.add('is-unavailable'); }
      b.addEventListener('click', () => {
        btns.forEach((x) => x.classList.remove('is-active')); b.classList.add('is-active');
        chosen = b; buy.disabled = false; buy.textContent = 'Buy ' + money(tier.dataset.tier) + ' pack · ' + b.textContent.trim();
        left.textContent = n + ' left in ' + b.textContent.trim();
      });
    });
    if (!total) { buy.disabled = true; buy.textContent = 'Sold out'; }
    buy.addEventListener('click', async () => {
      if (!chosen) return;
      buy.disabled = true; buy.textContent = 'Picking…';
      try {
        const t = tier.dataset.tier, size = chosen.dataset.size;
        const prize = await pickPrize(t, size);
        if (!prize) { buy.textContent = 'Just sold out'; left.textContent = 'Try another size'; return; }
        // one pack per order: start from an empty cart
        await fetch('/cart/clear.js', { method: 'POST' });
        const r = await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: prize.variantId, quantity: 1, properties: { _gacha_tier: t, _gacha_size: size, _gacha_prize: prize.title, _gacha_img: prize.image } }] }) });
        if (!r.ok) throw new Error('add failed');
        location.href = '/checkout';
      } catch (e) { buy.disabled = false; buy.textContent = 'Try again'; }
    });
  });
})();

/* ---------------- PDP: installments info → Shopify's own popup ---------------- */
document.addEventListener('click', (e) => {
  const btn = e.target.closest('[data-rv-terms-info]');
  if (!btn) return;
  const terms = btn.closest('.installments')?.querySelector('shopify-payment-terms');
  const inner = terms && (terms.shadowRoot || terms).querySelector('button, a');
  if (inner) inner.click();
});

/* ---------------- Privacy settings link: only where consent is required, reopens Shopify's banner ---------------- */
(() => {
  const btn = $('[data-rv-privacy]');
  if (!btn) return;
  btn.addEventListener('click', () => {
    const pb = window.privacyBanner;
    if (pb && pb.showPreferences) pb.showPreferences();
    else if (pb && pb.loadBanner) pb.loadBanner();
  });
})();


/* ---------------- Grid: chevrons (desktop) and swipe (touch) cycle through product images ---------------- */
(() => {
  const cycle = (media, dir) => {
    let urls = []; try { urls = JSON.parse(media.dataset.rvGallery) || []; } catch (err) {}
    if (urls.length < 2) return;
    const img = media.querySelector('.rv-card__img--primary'); if (!img) return;
    const card = media.closest('.rv-card'); if (card) card.classList.add('is-cycling');
    let i = Number(media.dataset.rvIndex || 0) + dir;
    i = (i + urls.length) % urls.length; media.dataset.rvIndex = i;
    const u = urls[i];
    img.srcset = u.replace(/width=600/, 'width=300') + ' 300w, ' + u + ' 600w, ' + u.replace(/width=600/, 'width=800') + ' 800w';
    img.src = u;
  };
  let swipedAt = 0;
  document.addEventListener('click', (e) => {
    if (Date.now() - swipedAt < 600 && e.target.closest('.rv-card__link')) { e.preventDefault(); e.stopPropagation(); return; }
    const btn = e.target.closest('[data-rv-nav]');
    if (!btn) return;
    e.preventDefault(); e.stopPropagation();
    const media = btn.closest('[data-rv-gallery]'); if (media) cycle(media, Number(btn.dataset.rvNav));
  }, true);
  let sx = 0, sy = 0, target = null;
  document.addEventListener('touchstart', (e) => {
    target = e.target.closest?.('[data-rv-gallery]'); if (!target) return;
    sx = e.touches[0].clientX; sy = e.touches[0].clientY;
  }, { passive: true, capture: true });
  document.addEventListener('touchend', (e) => {
    if (!target) return;
    const dx = e.changedTouches[0].clientX - sx, dy = e.changedTouches[0].clientY - sy;
    if (Math.abs(dx) > 30 && Math.abs(dx) > Math.abs(dy) * 1.5) { cycle(target, dx < 0 ? 1 : -1); swipedAt = Date.now(); }
    target = null;
  }, { passive: true, capture: true });
})();

/* ---------------- Grid: mobile quick add (+ opens the size tray) ---------------- */
document.addEventListener('click', (e) => {
  const plus = e.target.closest('[data-rv-plus]');
  const open = $$('.rv-card.is-quick-open');
  if (plus) {
    e.preventDefault(); e.stopPropagation();
    const card = plus.closest('.rv-card');
    open.forEach((c) => { if (c !== card) c.classList.remove('is-quick-open'); });
    card.classList.toggle('is-quick-open');
    return;
  }
  if (open.length && !e.target.closest('.rv-quick')) open.forEach((c) => c.classList.remove('is-quick-open'));
}, true);
